import { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export interface ContactUsIconProps {
  color: string;
}

export const ContactUsIcon: FC<ContactUsIconProps> = ({ color }) => {
  return (
    <SvgIcon>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M19.8343 17.5428C20.2433 17.9518 20.3017 18.6529 19.8927 19.062L19.4253 19.5294C18.6072 20.1722 17.0296 21.1655 14.8676 21.2823C10.6606 21.5161 7.50529 18.2439 6.16137 16.9C4.81746 15.4977 1.77903 12.4592 2.01276 8.42748C2.12962 6.26553 3.12295 4.68789 3.76569 3.86985L4.23314 3.4024C4.64216 2.99338 5.2849 3.05181 5.75235 3.46083L8.49862 6.2071C9.14136 6.84984 9.08293 7.78474 8.44019 8.36905L7.21313 9.47925C6.86255 9.7714 6.80412 10.2973 7.03784 10.6479C7.68058 11.5828 8.55705 12.693 9.72568 13.8032C10.719 14.7381 11.6539 15.4392 12.5304 15.9651C12.9394 16.1988 13.4653 16.1988 13.8159 15.9067L15.3935 14.5628C15.8025 14.2706 16.3284 14.2706 16.7374 14.6212L19.8343 17.5428Z'
          stroke={color}
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.1797 2C12.1797 2 20.3016 3.40235 21.1781 10.94'
          stroke={color}
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.1797 5.68115C12.1797 5.68115 16.7958 6.09017 17.3801 10.94'
          stroke={color}
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
